import { BottomSheet, Text, Title, type UseModalState } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { CLIPBOARD_SCORE } from "@src/appV2/ClipboardScore/constants";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { type Shift } from "@src/appV2/Shifts/Shift/types";

import { Button } from "../../../components/Button";

interface ShiftBookingConflictBottomSheetProps {
  modalState: UseModalState;
  onConfirm: () => void;
  onClose: () => void;
  conflictingShift: Shift;
}

export function ShiftBookingConflictBottomSheet(props: ShiftBookingConflictBottomSheetProps) {
  const { modalState, onConfirm, onClose, conflictingShift } = props;

  const conflictedFacilityName = conflictingShift.facility.name;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth size="large" variant="contained" onClick={onConfirm}>
            View My Shifts
          </Button>
          <Button fullWidth size="large" variant="outlined" onClick={onClose}>
            Go Back
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent>
        <Stack spacing={6} alignItems="center" sx={{ py: 4 }}>
          <Title semibold variant="h4" component="h4" textAlign="center">
            You&apos;re booked for a conflicting shift
          </Title>
          <Text
            color={(theme) => theme.palette.text.secondary}
            sx={{ textAlign: "center" }}
            variant="body1"
          >
            The shift you are invited to overlaps with your booked shift at {conflictedFacilityName}
            . You can cancel your other booked shift to accept this invite ({CLIPBOARD_SCORE}{" "}
            penalties may apply).
          </Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
